import { usePage } from "@inertiajs/react"
import { AlertCircle } from "lucide-react"
import type { PageProps } from "@/types/inertia"
import type { MonthlyCategoryKey } from "@/lib/datasetRegistry"

// The monthly-upload key surface lives in datasetRegistry.ts (the single TS
// source); this component only renders the per-page warning for one key.
export type { MonthlyCategoryKey }

type Props = {
  categoryKey: MonthlyCategoryKey
  label: string
}

export function MonthlyUploadAlert({ categoryKey, label }: Props) {
  const { props } = usePage<PageProps>()
  const status = props.monthly_upload_status?.[categoryKey]

  if (!status || status.completed) return null

  const currentMonthYear = new Date().toLocaleDateString("id-ID", {
    month: "long",
    year: "numeric"
  })

  return (
    <div className="mt-6 rounded-lg border border-warning/20 bg-warning-faded p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="w-5 h-5 shrink-0 text-warning-display" />
        <div className="flex-1 text-sm text-ink-body">
          <span className="font-semibold text-warning-display">Peringatan: </span>
          Data bulanan untuk <strong>{label}</strong> pada bulan berjalan ({currentMonthYear}) belum lengkap.
          {status.latest_period ? (
            <span> Sistem saat ini menggunakan data periode <strong>{status.latest_period}</strong> sebagai acuan sementara.</span>
          ) : (
            <span> Tidak ada data periode sebelumnya yang ter-upload di database.</span>
          )}
          {status.uploaded_count !== undefined && (
            <span className="block mt-1 font-medium text-xs text-ink-muted">
              Baru di-upload: {status.uploaded_count} dari {status.total_count} distributor/akun.
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
